import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { JobRoutingModule } from './job-routing.module'
import { JobComponent } from './job/job.component'
import { SwiperModule } from 'ngx-swiper-wrapper'
import { CustomTranslateModule } from '@flowaccount/landing'
import { WorkWithUsComponent } from './work-with-us/work-with-us.component'
import { BoxFormatComponent } from './box-format/box-format.component'
import { MissionComponent } from './work-with-us/mission/mission.component'
import { InvestorComponent } from './work-with-us/investor/investor.component'
import { TechLogoComponent } from './work-with-us/tech-logo/tech-logo.component'
import { OurSoftwareComponent } from './work-with-us/our-software/our-software.component'
import { DevBenefitComponent } from './work-with-us/dev-benefit/dev-benefit.component'
import { JobPositionComponent } from './work-with-us/job-position/job-position.component'
import { PerkComponent } from './work-with-us/perk/perk.component'
import { AccountantInTechComponent } from './accountant-in-tech/accountant-in-tech.component'
import { AccountantBenefitComponent } from './accountant-in-tech/accountant-benefit/accountant-benefit.component'
import { AccountantWelfareComponent } from './accountant-in-tech/accountant-welfare/accountant-welfare.component'
import { AccountantHiringComponent } from './accountant-in-tech/accountant-hiring/accountant-hiring.component'
import { AccountantGrowUpComponent } from './accountant-in-tech/accountant-grow-up/accountant-grow-up.component'
import { AccountantJoinComponent } from './accountant-in-tech/accountant-join/accountant-join.component'
import { CoreModule } from '../../core.module';
import { JobOpenningComponent } from './work-with-us/job-openning/job-openning.component'
import { JobOpenningDetailComponent } from './work-with-us/job-openning-detail/job-openning-detail.component'

@NgModule({
  declarations: [
    JobComponent,
    WorkWithUsComponent,
    BoxFormatComponent,
    MissionComponent,
    InvestorComponent,
    TechLogoComponent,
    OurSoftwareComponent,
    DevBenefitComponent,
    JobPositionComponent,
    PerkComponent,
    AccountantInTechComponent,
    AccountantBenefitComponent,
    AccountantWelfareComponent,
    AccountantHiringComponent,
    AccountantGrowUpComponent,
    AccountantJoinComponent,
    JobOpenningComponent,
    JobOpenningDetailComponent,
  ],
  imports: [
    CommonModule,
    JobRoutingModule,
    CoreModule.forRoot(),
    // swiper
    // SwiperModule,
    CustomTranslateModule.forChild({ path: 'job' }),
  ],
  providers: [],
})
export class JobModule {}
